(ns bec-core.cljs.service-worker
  (:require [reagent.core :as r]
            [cljs.core.async :as async]
            [cljs.core.async.interop :refer-macros [<p!]]
            [tick.core :as t]))

(defonce registration (r/atom nil))
(defonce messages (r/atom nil))
(defonce deferred-prompt (atom nil))

;; (defn install-prompt []
;;   (when @deferred-prompt
;;     (.prompt @deferred-prompt)
;;     (async/go
;;       (let [outcome (<p! (. @deferred-prompt -userChoice))]
;;         (cljs.pprint/pprint (str "on-click: " (.-outcome outcome)))
;;         (reset! deferred-prompt nil)))))

;; (defn before-install-prompt-listener []
;;   (js/window.addEventListener "beforeinstallprompt"
;;     (fn [event]
;;       (.preventDefault event)
;;       (reset! deferred-prompt event)
;;       (cljs.pprint/pprint "before install prompt"))))

;; (defn app-installed-listener []
;;   (js/window.addEventListener "appinstalled"
;;     (fn [event]
;;       (println "appinstalled")
;;       (async/go
;;         (let [outcome (<p! (. @deferred-prompt -userChoice))]
;;           (cljs.pprint/pprint (str "appinstalled: " (.-outcome outcome)))
;;           (reset! deferred-prompt nil)))
;;       (cljs.pprint/pprint "PWA installed"))))

;; (defn register [& [{:keys [on-update-found on-message on-error]}]]
;;   (when (js-in "serviceWorker" js/navigator)
;;     (try
;;       (-> (js/navigator.serviceWorker.register "service-worker.js")
;;         (.then
;;           (fn [reg]
;;             (reset! registration reg)
;;             (js/console.log "service worker registered")
;;             (set! reg.onupdatefound
;;               (fn [event]
;;                 (println "update found")))
;;             (set! reg.onmessage
;;               (fn [event]
;;                 (println "Service worker message")
;;                 (let [message (js->clj (.-data event) :keywordize-keys true)
;;                       message-ts (assoc message :message-received-ts (t/now))]
;;                   (when (:id message-ts)
;;                     (swap! messages
;;                       assoc-in [(:id message-ts) (::message-received-ts message-ts)] message-ts)))
;;                 (cljs.pprint/pprint (.-data event))))
;;             (set! reg.onerror
;;               (fn [event]
;;                 (println "Service worker error")
;;                 (cljs.pprint/pprint (.-data event))
;;                 (cljs.pprint/pprint (js-keys event)))))))

;;       (catch js/Object err (js/console.error "Failed to register service worker" err)))))

;; (defn post-message [message]
;;   (try
;;     (-> (.-ready js/navigator.serviceWorker)
;;       (.then
;;         (fn [reg]
;;           (let [message "hello SW"]
;;             (println message)
;;             (. (. reg -active) postMessage message)))))
;;     (catch js/Object err (js/console.error "Service worker was not ready to recieve message" err))))

;; (defn activate []
;;   (register)
;;   (before-install-prompt-listener)
;;   (app-installed-listener))
